import { render, staticRenderFns } from "./iconInfo.vue?vue&type=template&id=30c683a9"
import script from "./iconInfo.vue?vue&type=script&lang=js"
export * from "./iconInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports